let get_showCus = function() {
	if (this.get_showCus.active) {
		this.CustomerModal(this.get_showCus.item, this.get_showCus.idx);
	}
};
export default get_showCus;
